import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.manageDomainSearchScreenshot()
    this.clearCacheAfterLogout()
  }

  manageDomainSearchScreenshot() {
    $(".feature-point-location").on("click", function () {
      $(".feature-point-location").removeClass("selected")
      $(this).addClass("selected")
      $(".feature-legend").removeClass("selected")
      $("#" + $(this).attr("id") + "-legend").addClass("selected")
    })

    $(".feature-legend").on("click", function () {
      $(".feature-legend").removeClass("selected")
      $(this).addClass("selected")
      $(".feature-point-location").removeClass("selected")
      $("#" + $(this).attr("id").replace("-legend", "")).addClass("selected")
    })
  }

  clearCacheAfterLogout() {
    if (App.findGetParameter("logged_out") != null) {
      fetch("/internal/clear-cache")
    }
  }
}
